import React from 'react';

import {Form, Button} from '@components';
import {Props} from './types';
import * as hooks from './hooks';

import './index.scss';

const Detail: React.FC<Props> = props => {
  const initialValues = {
    firstName: props.users.detail.firstName,
    lastName: props.users.detail.lastName,
    lastKana: props.users.detail.lastKana,
    firstKana: props.users.detail.firstKana,
    prefecture: props.users.detail.prefecture,
    authLevel: props.users.detail.authLevel,
    teamId: props.me.teamId,
    email: props.users.detail.email || '-',
    phoneNumber: props.users.detail.phoneNumber || '-',
  };

  hooks.useMount({...props}, props.actions);

  return (
    <div className="a__admin-detail">
      <div className="b__title">管理者詳細</div>
      <div className="b__main">
        <div className="w__create-field">
          <div className="w__information-field">
            <Form.User
              initialValues={initialValues}
              detail
              me={props.me}
              users={props.users}
              handleSubmit={() => {}}
              submitText=""
            />
          </div>
        </div>
        <div className="w__side-buttons">
          <Button.Normal
            text="特権管理者を編集する"
            onClick={() => props.history.push(`${props.match.url}/edit`)}
            color="yellow"
            className="b__edit"
            disabled={!props.users.detail.lastName}
          />
          <Button.Normal
            text="前のページに戻る"
            onClick={() => props.history.goBack()}
          />
        </div>
      </div>
    </div>
  );
};

export default Detail;
